import type { IControlStatus } from '@/types/control'
export const CONTROL_STATUS: { [K in IControlStatus]: string } = {
  notApplicable: 'Not Applicable',
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  completed: 'Completed',
}

export const CONTROL_TABLE = {
  TITLE: 'Controls',
  SEARCH_PLACEHOLDER: 'Search controls...',
}

export const CONTROL_DRAWER = {
  IMPLEMENTATION_GUIDE: 'Implementation Guide',
  MISSING_IMPLEMENTATION_GUIDE: 'Missing implementation guide',
  MISSING_STANDARD_DESCRIPTION: 'Missing standard description',
  NOT_FOUND_TITLE: 'Control Not Found',
  NOT_FOUND_DESCRIPTION: 'The control you are looking for does not exist.',
  SELECT_OWNER: 'Select Owner',
  STANDARD_DESCRIPTION: 'Standard Description',
  UPLOAD_EVIDENCES: 'Upload Evidences',
  CONTROL_UPDATED: 'Control updated',
  STANDARD_CODE: 'Standard ID',
  STATUS: 'Status',
  OWNER: 'Owner',
  UPDATING: 'Updating control...',
  CONTROL_DETAILS: 'Control Details',
  DESCRIPTION: 'Description',
  ATTRIBUTES: 'Attributes',
  RELATED_DOCUMENTS: 'Related Documents',
  RELATED_EVIDENCES: 'Related Evidences',
}

export const CONTROL_FILTERS = {
  FILTER_BY_OWNER: 'Filter by Owner',
  FILTER_BY_CLUSTER: 'Filter by Cluster',
  FILTER_BY_STANDARD: 'Filter by Standard',
  ALL: 'All',
}

export const CONTROL_BULK_ACTIONS = {
  SELECTED: 'selected',
  CONTROL: 'control',
  CONTROLS: 'controls',
  UPDATING: 'Updating...',
  CLEAR: 'Clear',
}

export const CONTROL_OWNER_SELECTOR = {
  SELECT_OWNER: 'Select owner',
  SEARCH_USERS: 'Search users...',
  LOADING: 'Loading...',
  NO_USER_FOUND: 'No user found.',
}

export const CONTROL_STATUS_SELECTOR = {
  SELECT_STATUS: 'Select status',
}

export const CONTROL_COLUMN_FILTER = {
  ALL: 'All',
  CLEAR: 'Clear',
  SEARCH_PLACEHOLDER: 'Search...',
  NO_RESULTS: 'No results found.',
}
